// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import useBuyingList from "@store/Framework/Common/Hooks/useBuyingList/useBuyingList";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import TextField, { TextFieldPresentationProps } from "@store/MobiusOverrides/TextField/TextField";
import { searchInputStyles } from "@store/Overrides/Widgets/Header/SearchInput";
import React from "react";

const buyingListManagementSearchStyles: TextFieldPresentationProps = {
    ...searchBoxStyles.search,
    cssOverrides: {
        ...searchBoxStyles.search?.cssOverrides,
        formField: undefined,
    },
};

const BuyingListManagementSearch = () => {
    const { setBuyingListQuery } = useBuyingList();
    return (
        <TextField
            onChange={event => setBuyingListQuery(event.currentTarget.value)}
            placeholder={translate("Filter by Buying List Name")}
            data-test-selector="buyingListManagementSearch_searchBox"
            {...buyingListManagementSearchStyles}
        />
    );
};

const widgetModule: CustomWidgetModule = {
    component: BuyingListManagementSearch,
    definition: {
        group: "Buying List",
    },
};

export default widgetModule;
